import { FIELD_KEYS, type RuleDefinition } from '../domain/types';
import { getCell } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { finding } from './helpers';

export const BQ015: RuleDefinition = {
  id: 'BQ015',
  name: '无法取得公式结果',
  description: '检查公式单元格是否包含可读取的缓存结果；本工具不执行 Excel 公式重算。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: FIELD_KEYS,
  message: '单元格包含公式，但文件中没有可读取的缓存结果。',
  suggestion: '请使用 Excel 或兼容软件重新计算并保存工作簿后再检查；本工具不承担公式重算。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      FIELD_KEYS.flatMap((field) => {
        const cell = getCell(row, field);
        if (cell === undefined || cell.formula === null || cell.formulaResultAvailable) return [];
        return [
          finding(row, field, {
            currentValue: `=${cell.formula}`,
            message: `${getFieldDefinition(field).label}包含公式，但没有可读取的缓存结果；本工具不会重算 Excel 公式。`,
          }),
        ];
      }),
    ),
};
